<template>
  <section>
    <div>
      <v-dialog
        v-model="popupActive"
        width="auto"
        persistent
        no-click-animation
        transition="dialog-transition"
        :content-class="$style.dialog"
      >
        <v-card>
          <v-toolbar color="grey-lighten-1 flex-grow-0">
            <v-toolbar-title class="mr-2 d-flex align-center">
              {{ $t('complaintForm.scanQr.dialogHeadline') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="multipleDevices" icon :title="$t('general.close')" @click="switchSources">
              <v-icon>mdi-axis-z-rotate-counterclockwise</v-icon>
            </v-btn>
            <v-btn icon :title="$t('general.close')" @click="setPopupInactiveNoResult()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4">
            <section>
              <p v-if="inputDeviceInitFailed">
                {{ $t('complaintForm.scanQr.couldNotAccessDevice') }}
              </p>
              <video
                v-else
                id="zxing-aztec-video"
                :class="$style['zxing-video']"
                @click.stop
              ></video>
            </section>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-btn
        color="primary"
        icon
        small
        :height="36"
        :width="36"
        :elevation="0"
        tabindex="-1"
        :title="$t('general.scanAztecCodeButton')"
        @click="scanBikeCode"
        ><v-icon>mdi-qrcode-scan</v-icon>
      </v-btn>
    </div>
  </section>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library'

export default {
  name: 'AztecCameraScanner',
  data() {
    return {
      codeReader: undefined,
      selectedDeviceId: undefined,
      popupActive: false,
      inputDeviceInitFailed: false,
      multipleDevices: false,
    }
  },
  methods: {
    switchSources() {
      this.codeReader.listVideoInputDevices().then(videoInputDevices => {
        if (this.selectedDeviceId == videoInputDevices[1].deviceId) {
          this.selectedDeviceId = videoInputDevices[0].deviceId
          console.log(this.selectedDeviceId)
          this.setPopupInactive()
          this.scanBikeCodeSwitch(this.selectedDeviceId)
        } else {
          this.selectedDeviceId = videoInputDevices[1].deviceId
          console.log(this.selectedDeviceId)
          this.setPopupInactive()
          this.scanBikeCodeSwitch(this.selectedDeviceId)
        }
        console.log(videoInputDevices)
      })
    },
    setPopupInactiveResult() {
      this.codeReader.reset()
      this.popupActive = false
    },
    setPopupInactive() {
      this.popupActive = false
    },
    setPopupInactiveNoResult() {
      console.log('close')
      location.reload()
    },
    async setPopupActive() {
      this.popupActive = true
    },
    async scanBikeCode() {
      this.codeReader = new BrowserMultiFormatReader()
      this.setPopupActive()
      this.codeReader
        .listVideoInputDevices()
        .then(videoInputDevices => {
          if (videoInputDevices.length > 1) {
            this.selectedDeviceId = videoInputDevices[1].deviceId
            this.multipleDevices = true
          } else {
            this.selectedDeviceId = videoInputDevices[0].deviceId
          }
          this.inputDeviceInitFailed = false
          this.codeReader.decodeFromVideoDevice(
            this.selectedDeviceId,
            'zxing-aztec-video',
            result => {
              if (result) {
                const serNum = result.text.replaceAll(' ', '').split('=')
                this.$emit('scanResult', serNum[0])
                this.setPopupInactiveResult()
              }
            },
          )
        })
        .catch(() => {
          this.inputDeviceInitFailed = true
        })
    },

    async scanBikeCodeSwitch(deviceId) {
      this.setPopupActive()
      this.selectedDeviceId = deviceId
      this.inputDeviceInitFailed = false
      this.codeReader.decodeFromVideoDevice(this.selectedDeviceId, 'zxing-aztec-video', result => {
        if (result) {
          const serNum = result.text.replaceAll(' ', '').split('=')
          this.$emit('scanResult', serNum[0])
          this.setPopupInactiveResult()
        }
      })
    },
  },
}
</script>

<style lang="scss" module>
.dialog {
  min-width: 300px;
}

.zxing-video {
  width: 300px;
  height: 200px;

  background-color: var(--grey-lighten-2);
  border: 1px solid;
  border-color: var(--grey);
}
</style>
